<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button icon-only (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label>
      Pick the Product(s)
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content>
    <div class="ion-padding ion-margin" *ngIf="stats.length == 0">
      There is no product available
    </div>
    <p-table
      #table
      *ngIf="stats.length != 0"
      dataKey="ID"
      [autoLayout]="true"
      [(selection)]="selectedProducts"
      [columns]="cols"
      [value]="stats"
      [loading]="isLoading"
      [responsive]="true"
      [scrollable]="true"
      [totalRecords]="stats.length"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    >
      <ng-template pTemplate="caption">
        <div>
            <ion-searchbar
              class="ion-no-padding"
              type="search"
              animated="true"
              placeholder="product detail"
              show-cancel-button="focus"
              (input)="search($event)"
            >
            </ion-searchbar>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            <div>
              {{ col.header }}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </div>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-stat let-columns="columns">
        <tr>
          <td>
            <p-tableCheckbox [value]="stat"></p-tableCheckbox>
          </td>
          <td *ngFor="let col of columns">
            {{ stat[col.field] }}
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="summary">
        <ion-button
          class="save-button"
          (click)="sendProductList(selectedProducts)"
        >
          Complete
        </ion-button>
      </ng-template>
    </p-table>
</ion-content>
